import React from 'react';

const ExplorePage = ({ profileData }) => {
  const exploreCategories = [
    {
      title: 'DeFi Protocols',
      description: 'Discover decentralized finance applications',
      icon: '🏦'
    },
    {
      title: 'NFT Marketplaces',
      description: 'Explore and trade non-fungible tokens',
      icon: '🖼️'
    },
    {
      title: 'Gaming',
      description: 'Play-to-earn games and gaming tokens',
      icon: '🎮'
    },
    {
      title: 'Social',
      description: 'Decentralized social networks and communities',
      icon: '👥'
    }
  ];

  return (
    <div>
      <h1 style={{ fontSize: '32px', fontWeight: '700', marginBottom: '12px' }}>
        Explore
      </h1>
      <p style={{ fontSize: '16px', color: '#666', marginBottom: '40px' }}>
        Discover new applications and opportunities in the crypto ecosystem.
      </p>

      <div style={{ marginBottom: '40px' }}>
        <h2 style={{ fontSize: '24px', fontWeight: '600', marginBottom: '20px' }}>
          Categories
        </h2>
        <div className="earn-categories">
          {exploreCategories.map((category, index) => (
            <div key={index} className="category-card">
              <div style={{ fontSize: '24px', marginBottom: '12px' }}>
                {category.icon}
              </div>
              <div className="category-title">{category.title}</div>
              <div className="category-description">{category.description}</div>
            </div>
          ))}
        </div>
      </div>

      <div className="tokens-section">
        <div className="section-header">
          <h2 className="section-title">Trending Applications</h2>
        </div>

        <div className="empty-state">
          <div className="empty-icon">🧭</div>
          <div className="empty-title">Coming Soon</div>
          <div className="empty-description">
            Trending applications and protocols will be showcased here.
          </div>
        </div>
      </div>
    </div>
  );
};

export default ExplorePage;
